export const FIXABLE_ON_CLINICS = ['practice_unreviewed', 'not_a_practice'];

export function heldBackLabel(code) {
  const labels = {
    practice_unreviewed: 'Not yet confirmed as a practice',
    not_a_practice: 'Marked as not a practice',
    no_clinic_record: 'No clinic record in this company file',
    no_billing_email: 'No billing email on file',
    inactive: 'Archived in QuickBooks',
    sub_customer: 'A sub-customer, billed through its parent',
    non_usd: 'Not billed in dollars',
  };
  return typeof code === 'string' && Object.prototype.hasOwnProperty.call(labels, code)
    ? labels[code]
    : 'The reason needs review. Contact MedEffects for help.';
}

export function refusalLabel(code) {
  const labels = {
    paused: 'Statements are paused for this customer',
    no_email: 'No billing email on file',
    unusable_email: 'The billing email is not a usable address',
    does_not_reconcile: 'Total disagrees with QuickBooks',
    nothing_owed: 'Nothing owed',
    already_sent_this_week: 'Already sent this week',
    render_failed: 'Their statement could not be produced',
    statement_missing: 'No statement was built for them',
    transport_refused: 'The mailbox refused the address',
    released_by_admin: 'Released by an admin so the week could be re-run',
  };
  return typeof code === 'string' && Object.prototype.hasOwnProperty.call(labels, code)
    ? labels[code]
    : 'The reason needs review. Contact MedEffects for help.';
}

const STATEMENT_OUTCOMES = new Set(['claimed', 'sent', 'failed', 'simulated', 'skipped']);
export const statementOutcomeLabel = (value) =>
  STATEMENT_OUTCOMES.has(value) ? value : 'The outcome needs review. Contact MedEffects for help.';
